<template>
  <div>
    <branded-box class="footer">
      <p class="footer__item">
        Dave Bennett Distribution Ltd <br />
        Whiteway Road <br />
        Queenborough <br />
        Kent <br />
        ME11 5PP</p>
    <p class="footer__item"><svg-icon icon="phone" />01795 665214</p>
    <div class="footer__item footer__item--vertical-list">
      <p><svg-icon icon="envelop" /><a href="mailto:enquiries@dave-bennett.co.uk">enquiries@dave-bennett.co.uk</a></p>
      <img src="../assets/rha.png" class="rha-logo" alt="Dave Bennett Distribution is a proud member of the RHA"/>
    </div>
    </branded-box>
    <cookie-law button-decline @accept="acceptCookies" @decline="declineCookies">
      <template v-slot:message>
        <p>This website shares anonymous data (including cookies) with Google Analytics for website monitoring and performance purposes</p>
      </template>
    </cookie-law>
  </div>
</template>

<script>

  import '@/assets/icons/phone'
  import '@/assets/icons/envelop'
  import BrandedBox from "./branded-box";
  import CookieLaw from 'vue-cookie-law'
  import router from "../router";
  import Vue from "vue";
  import VueGtag from "vue-gtag";

  export default {
    components: {BrandedBox, CookieLaw,},
    methods : {
      acceptCookies() {

        Vue.use(VueGtag, {
          config: { id: "UA-174384298-1" },
          debug: {
            enabled: true,
            trace: true,
            sendHitTask: true
          },
        }, router);


      },
      declineCookies() {

      }
    }
  }

</script>

<style lang="scss" scoped>

  .footer {

    margin-top: 1rem;

    display: flex;
    justify-content: space-around;
    align-items: flex-start;

    padding: 0.5rem;

    &__item {

      &--vertical-list {
        display: flex;
        flex-flow: column;
        align-items: center;
      }
    }

  }

  .rha-logo {
    width: 150px;
    margin-top: 1rem;
  }



  @media (max-width: 1000px) {
    .footer {
      flex-flow: column;
      align-items: center;

      &__item {
        margin-bottom: 1rem;
      }
    }
  }

</style>